import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X, ShoppingCart } from 'lucide-react';

import icon from '../../images/icononly_transparent_nobuffer.png';
import Badge from '../ui/Badge';
import { useCart } from '../../context/CartContext';
import AuthWidget from './AuthWidget';

const NAV_LINKS = [
  { to: '/', label: 'Home', end: true },
  { to: '/products', label: 'Shop All', end: false },
];

export default function Header() {
  const { count: cartCount, openDrawer } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);

  const closeMobile = () => setMobileOpen(false);

  const navList = (mobile) => (
    <nav className={`ss-nav ${mobile ? 'ss-nav--mobile' : ''}`} aria-label={mobile ? 'Mobile' : 'Primary'}>
      {NAV_LINKS.map((l) => (
        <NavLink
          key={l.to}
          to={l.to}
          end={l.end}
          className={({ isActive }) => (isActive ? 'is-active' : undefined)}
          onClick={mobile ? closeMobile : undefined}
        >
          {l.label}
        </NavLink>
      ))}
    </nav>
  );

  return (
    <header className="ss-header">
      <div className="ss-container ss-header__inner">
        <Link to="/" className="ss-logo" onClick={closeMobile}>
          <img src={icon} alt="Sustainably Sprouted home" className="ss-logo__mark" />
          <span className="ss-logo__word">Sustainably Sprouted</span>
        </Link>

        {/* desktop: inline nav */}
        <div className="ss-only-desktop">{navList(false)}</div>

        <div className="ss-header__actions">
          <button
            type="button"
            className="ss-cart-link"
            aria-label={`Cart, ${cartCount} item${cartCount === 1 ? '' : 's'}`}
            onClick={() => {
              closeMobile();
              openDrawer();
            }}
          >
            <ShoppingCart size={22} aria-hidden="true" />
            {cartCount > 0 && <Badge>{cartCount}</Badge>}
          </button>

          <div className="ss-only-desktop">
            <AuthWidget variant="desktop" />
          </div>

          <button
            className="ss-hamburger ss-only-mobile"
            aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={mobileOpen}
            aria-controls="ss-mobile-nav"
            onClick={() => setMobileOpen((o) => !o)}
          >
            {mobileOpen ? <X size={24} aria-hidden="true" /> : <Menu size={24} aria-hidden="true" />}
          </button>
        </div>
      </div>

      {/* mobile: collapsible panel */}
      <div id="ss-mobile-nav" className={`ss-mobile-panel ${mobileOpen ? 'is-open' : ''}`}>
        <div
          className="ss-container"
          style={{
            paddingBlock: 'var(--ss-space-4)',
            display: 'flex',
            flexDirection: 'column',
            gap: 'var(--ss-space-4)',
          }}
        >
          {navList(true)}
          <AuthWidget variant="mobile" onNavigate={closeMobile} />
        </div>
      </div>
    </header>
  );
}
